import { render, staticRenderFns } from "./RequestsTableActions.vue?vue&type=template&id=1a06931b&"
import script from "./RequestsTableActions.vue?vue&type=script&lang=js&"
export * from "./RequestsTableActions.vue?vue&type=script&lang=js&"
import style0 from "./RequestsTableActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports